import { createFileRoute } from '@tanstack/react-router'
import { ProductCategoryCreateView } from '@/features/product-categories/product-categories'

export const Route = createFileRoute('/_authenticated/product-categories/new')({
  component: ProductCategoryCreateView,
})
